    $(document).ready(function () {
        var errorEl = document.getElementsByClassName('field-validation-error')[0];
        if (!errorEl) { return; }
        var elementTextCheck = errorEl.innerText;
        if (elementTextCheck === pzLoginPage.v0) {
            $('<br />').appendTo(errorEl);
            $('<a class="confirm-link" onclick="RedirectToConfirm()" href="#" >' + pzLoginPage.v1 + '</a>').appendTo(errorEl);
        }
    });

    function RedirectToConfirm() {
        document.location.href = pzLoginPage.v2;
    }
